import BaseObject from './BaseObject';
import { Matrix4, Mesh } from 'three';
import { GingivaObjectDescription, MaterialTypes, ObjectTypes } from '@data/models';
import { GeometryProvider, MaterialsProvider } from '@data/providers';
import { WebGLScene } from '../WebGLScene';


class GingivaObject extends BaseObject {
  constructor(mesh: Mesh) {
    super(mesh, ObjectTypes.Gingiva);
  }

  static async create(
    description: GingivaObjectDescription,
    scene: WebGLScene,
    geometryProvider: GeometryProvider,
    materialsProvider: MaterialsProvider
  ) {
    const mesh = new Mesh(
      geometryProvider.getGeometryByDescription(description),
      materialsProvider.getMaterial(MaterialTypes.Gingiva)
    );

    const position = mesh.position.clone();
    const rotation = mesh.rotation.clone();
    const scale = mesh.scale.clone();

    if (description.transform) {
      const matrix = new Matrix4();
      matrix.fromArray(description.transform);
      matrix.transpose();
      mesh.applyMatrix4(matrix);
    }

    const obj = new GingivaObject(mesh);
    obj.setInitial(position, rotation, scale);
    scene.getRootObject().add(obj.mesh);

    obj.id = description.id;
    obj.visible = description.visible;

    return obj;
  }
}

export default GingivaObject;
